import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, inject } from '@angular/core';
import { DateSelectionService } from '../../services/date-selection.service';
import { DateConversionService } from '../../services/date-conversion.service';
import { NgbDate, NgbDatepicker, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  imports: [CommonModule, NgbDatepickerModule],
  standalone: true,
  selector: 'rx-calendar-date-selection',
  templateUrl: './calendar-date-selection.component.html',
    styleUrls: ['./calendar-date-selection.component.scss'],
})
export class CalendarDateSelectionComponent {
  dateSelectionService = inject(DateSelectionService);
  dateConversionService = inject(DateConversionService);

  @Input() startDate: Date;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() testIdPrefix: string;

  @ViewChild('datePicker') datePicker: NgbDatepicker;

  hoveredDate: NgbDate | null = null;
  
  dateTestId(idPrefix:string, date: NgbDate): string {
    return `${idPrefix}-month-${date.month}-day-${date.day}`;
  }

}
